import { httpGetAdapter } from '@/lib/adapters/httpGetAdapter';
import { yearsResponseSchema, type YearsResponse } from '@/schemas/years';

export const getYears = httpGetAdapter<YearsResponse, void>({
  url: '/v3/escolas/anosLetivos',
  schema: yearsResponseSchema,
});
